import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import {
  randomNumber,
  clearError,
  reduxDefaultStatusControl,
} from 'src/tools/helper';
import { EnumProductType } from 'src/types/common/product';
//import { getProduct } from '@/src/request/product/product';
import {
  validate as _validate,
  settleData,
  convertDatafromServer,
  defaultData,
} from '../tools';
import { isSameType } from '../../tools/commonDataCheck';
import { EnumModifiedType } from '../type';
import { ActionType } from 'src/types/common/common';

import { msg } from 'src/tools/message';
import { productSetReselectFilter } from './tools';
import {
  submitProductThunk,
  activateProductThunk,
  draftProductThunk,
  archiveProductThunk,
  duplicateProduct,
} from '../../tools/commonRequests';
import {
  getLinkedSalesChannels as _getLinkedSalesChannels,
  // getStockSubCollapseData as _getStockSubCollapseData,
} from 'src/pages/ProductEditor/tools/selectors';
import { EnumReducers } from 'src/store/constants';
import {
  onLinkedSalesChannelsProductsChange as _onLinkedSalesChannelsProductsChange,
  onLinkedSalesChannelsProductsDelete as _onLinkedSalesChannelsProductsDelete,
} from 'src/pages/ProductEditor/slice/common';

const defaultState = {
  ...reduxDefaultStatusControl,
  ...defaultData,
};
export const fetchProduct = createAsyncThunk(
  'fetchProductSet',
  async (a: any) => {
    console.log('a', a);
    if (a) {
      const response = await Promise.resolve(a);

      return response;
    } else {
      const response = await Promise.reject();

      return response;
    }
  },
);
function isCurrentType(pro) {
  const { productType } = pro || {};
  return productType === EnumProductType.Set;
}

function showSavedMsg() {
  msg.success('saved successfully!');
}

function convertProduct(state, product, priceTiers) {
  if (isCurrentType(product)) {
    const updatedProduct = updateState(
      convertDatafromServer(product, priceTiers),
    );
    console.log(updatedProduct);
    Object.keys(updatedProduct || {}).forEach((i) => {
      state[i] = updatedProduct[i];
    });
  }
}

const convertStatus = (state, product, priceTiers) => {
  const _p = product;
  convertProduct(state, _p, priceTiers);
  showSavedMsg();
};

const productSetSlice = createSlice({
  name: 'productSet',
  initialState: defaultState,
  reducers: {
    addMeasurementUnit(state, action) {
      state.measurementUnits = [...state.measurementUnits, action.payload];
      state.hasModified = true;
    },
    addBrands(state, action) {
      state.brands = [...state.brands, action.payload];
      state.hasModified = true;
    },
    setProductInfoData(state, action) {
      state.productInfo = {
        ...state.productInfo,
        ...clearError(action.payload),
      };
      state.hasModified = true;
    },
    setTags(state, action) {
      state.tags = { ...state.tags, ...clearError(action.payload) };
      state.hasModified = true;
    },
    setThumbnailImage(state, action) {
      state.thumbnailImage = action.payload;
      state.fileList = [];
      state.hasModified = true;
    },
    setCodes(state, action) {
      const codesCopy = state.productInfo.codes;
      codesCopy.push(action.payload);
      state.productInfo.codes = codesCopy;
      state.hasModified = true;
    },

    setPrice(state, action) {
      state.priceSettings = {
        ...state.priceSettings,
        ...clearError(action.payload),
      };
      state.hasModified = true;
    },
    setProductSet(state, action) {
      state.productSetItemsEmptyError = false;
      state.hasModified = true;
      const { type, item, products } = action.payload; //item是修改的的对象
      const { product, noOfUnit, modifiedType } = item || {};
      const { uuid: itemUuid } = product || {};
      const index = state.productSetItems.findIndex((i) => {
        return i.product.uuid === itemUuid;
      });
      if (typeof index === 'number') {
        if (type === ActionType.delete) {
          state.productSetItems.splice(index, 1);
          state.advancedPriceSettings = state.advancedPriceSettings.map((i) => {
            const { items } = i;
            return {
              ...i,
              items: items.filter((item) => {
                return item.productUuid !== itemUuid;
              }),
            };
          });
        }
        if (type === ActionType.modify) {
          state.productSetItems[index] = {
            ...state.productSetItems[index],
            ...clearError(item),
          };
          if (modifiedType === EnumModifiedType.noOfUnit) {
            state.advancedPriceSettings = state.advancedPriceSettings.map(
              (i) => {
                const { items } = i;
                return {
                  ...i,
                  items: items.map((item) => {
                    if (item.productUuid === itemUuid) {
                      return {
                        ...item,
                        noOfUnit,
                      };
                    } else {
                      return item;
                    }
                  }),
                };
              },
            );
          }
        }
      }
      if (type === ActionType.reselect) {
        state.productSetItems = products;
        const newAdvanced = productSetReselectFilter(
          state.advancedPriceSettings,
          products,
        );

        state.advancedPriceSettings = newAdvanced;
      }
    },
    setAdvancedPriceExpand(state, action) {
      const keys = action.payload;

      state.advancedPriceSettings.forEach((i) => {
        if (keys.includes(i.key)) {
          i.open = true;
        } else {
          i.open = false;
        }
      });
    },
    setAdvancedPrice(state, action) {
      state.hasModified = true;
      const { isDelete, index, settings = {} } = action.payload;
      if (isDelete) {
        state.advancedPriceSettings.splice(index, 1);
      } else {
        state.advancedPriceSettings[index] = {
          ...state.advancedPriceSettings[index],
          ...clearError(settings),
        };
      }
    },
    onHasModifiedChange(state) {
      state.hasModified = true;
    },
    setAdvancedPriceSubProduct(state, action) {
      state.hasModified = true;
      const { parentIndex, index, item } = action.payload;
      const oriItem = ((state.advancedPriceSettings[parentIndex] || {}).items ||
        [])[index];
      ((state.advancedPriceSettings[parentIndex] || {}).items || [])[index] = {
        ...oriItem,
        ...clearError(item),
      };
    },

    setAdvancedPriceAddNew(state) {
      state.hasModified = true;
      const currentAmount = (state.advancedPriceSettings || []).length + 1;
      let num = '';
      if (currentAmount < 10) {
        num = '0' + currentAmount;
      } else {
        num = `${currentAmount}`;
      }
      state.advancedPriceSettings = [
        ...state.advancedPriceSettings,
        {
          setPrice: 0,
          title: `Price ${num}`,
          notes: '',
          currency: null,
          key: randomNumber(),
          items: state.productSetItems.map((i) => {
            return {
              unitPrice: 0,
              noOfUnit: i.noOfUnit,
              productName: i.product.name,
              productUuid: i.product.uuid,
              key: randomNumber(),
            };
          }),
        },
      ];
    },
    setAdvancedPriceSettingsOpen(state) {
      state.hasModified = true;
      state.advancedPriceSettingsOpen = !state.advancedPriceSettingsOpen;
    },
    setDimensions(state, action) {
      state.hasModified = true;
      state.dimensions = { ...state.dimensions, ...clearError(action.payload) };
    },
    deleteCodes(state, action) {
      state.hasModified = true;
      state.productInfo.codes.splice(action.payload.index, 1);
    },
    setCustomInfomationItems(state, action) {
      state.hasModified = true;
      // state.priceSettings = { ...state.priceSettings, ...action.payload };
      const { isDelete, index, settings = {} } = action.payload;
      if (isDelete) {
        state.customsInformationItems.splice(index, 1);
      } else {
        state.customsInformationItems[index] = {
          ...(state.customsInformationItems[index] || {}),
          ...clearError(settings),
        };
      }
    },
    setCustomInfomationItemsAddNew(state) {
      state.hasModified = true;
      state.customsInformationItems = [
        ...(state.customsInformationItems || []),
        {
          key: randomNumber(),
          title: null,
          quantity: null,
          unitPrice: null,
          regionOfOrigin: null,
          hsCode: null,
        },
      ];
    },
    emptyData(state) {
      state.hasModified = false;
      Object.keys(defaultState || {}).forEach((i) => {
        state[i] = defaultState[i];
      });
    },
    setCodesTitle(state, action) {
      const { code, index } = action.payload;
      state.productInfo.codes[index].code = code;
      state.productInfo.codes[index].codeError = false;
      state.hasModified = true;
    },
    validate(state, action) {
      _validate(state, action);
    },

    onSubCollapseChange(state, action) {
      const { collapse } = action.payload;
      state.subCollapseOpen = { ...state.subCollapseOpen, ...(collapse || {}) };
    },
    onLinkedSalesChannelsProductsChange(state, action) {
      _onLinkedSalesChannelsProductsChange(state, action);
    },
    onLinkedSalesChannelsProductsDelete(state, action) {
      _onLinkedSalesChannelsProductsDelete(state, action);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProduct.fulfilled, (state, action: any) => {
      const {
        brands,
        measurementUnits,
        countries,
        currencies,
        product,
        inventoryUuid,
        dimensionUnits,
        wightUnits,
        priceTiers,
      } = action.payload;
      //console.log('action.payload', action.payload);
      const linkedSalesChannels = action.payload.linkedSalesChannels || [];
      if ((product || {}).uuid) {
        convertProduct(state, product, priceTiers);
      } else {
        state.loaded = true;
        // console.log('priceTiers', priceTiers);
        state.advancedPriceSettings = priceTiers.map((i) => {
          //初始化price tier
          const { uuid, ...rest } = i;
          return {
            ...rest,
            priceTierUuid: uuid,
            key: randomNumber(),
            items: [],
          };
        });
      }
      state.measurementUnits = measurementUnits;
      state.brands = brands;
      state.countries = countries;
      state.currencies = currencies;
      state.dimensionUnits = dimensionUnits;
      state.wightUnits = wightUnits;
      state.inventoryUuid = inventoryUuid;
      state.linkedSalesChannels = linkedSalesChannels;
      state.priceTiers = priceTiers;
    });

    builder.addCase(fetchProduct.rejected, (state, action) => {
      //state.status = EnumLoadingStatus.FAILED;
    });
    builder.addCase(submitProductThunk.fulfilled, (state, action) => {
      const { response: product, hideMsg } = action.payload;
      const _isCurrentType = isCurrentType(product);
      if (!hideMsg && _isCurrentType) {
        showSavedMsg();
      }
      convertProduct(state, product, state.priceTiers);
    });
    builder.addCase(activateProductThunk.fulfilled, (state, action) => {
      const _p = action.payload;
      convertStatus(state, _p, state.priceTiers);
    });
    builder.addCase(draftProductThunk.fulfilled, (state, action) => {
      const _p = action.payload;
      convertStatus(state, _p, state.priceTiers);
    });
    builder.addCase(archiveProductThunk.fulfilled, (state, action) => {
      const _p = action.payload;
      convertStatus(state, _p, state.priceTiers);
    });
    builder.addCase(duplicateProduct, (state, action) => {
      const { productType, name, status } = action.payload;
      const isSame = isSameType(EnumProductType.Set, productType);
      if (isSame) {
        state.uuid = null;
        state.productInfo.name = name;
        state.productInfo.sku = null;
        state.status = status;
      }
    });
    // ;
  },
});
export const getStateSelector = () => {
  return createSelector([(state: any) => state.productSet], (productSet) => {
    return settleData(productSet);
  });
};

export const getLinkedSalesChannels = () => {
  return _getLinkedSalesChannels(EnumReducers.productSet);
};

export const getSetAndDefaultPrice = () => {
  return createSelector(
    (state: any) => state.productSet.productSetItems,
    (state: any) => state.productSet.priceSettings.defaultSalePrice,
    (productSetItems, defaultSalePrice) => {
      return { productSetItems, defaultSalePrice };
    },
  );
};

const updateState = (newProduct = {}) => {
  //productSetItemsEmptyError
  return { ...newProduct, productSetItemsEmptyError: false };
};
export const {
  setProductInfoData,
  setCodes,
  deleteCodes,
  setCodesTitle,
  setTags,

  setPrice,
  setAdvancedPrice,
  // setAdvancedPriceOnBlur,
  setAdvancedPriceAddNew,
  setAdvancedPriceSettingsOpen,
  setDimensions,
  setCustomInfomationItems,
  setCustomInfomationItemsAddNew,
  emptyData,
  setThumbnailImage,
  validate,
  addMeasurementUnit,
  addBrands,
  setAdvancedPriceSubProduct,
  setProductSet,
  setAdvancedPriceExpand,

  onSubCollapseChange,
  onLinkedSalesChannelsProductsChange,
  onLinkedSalesChannelsProductsDelete,
  onHasModifiedChange,
} = productSetSlice.actions;

export default productSetSlice.reducer;
